// removed by extract-text-webpack-plugin
module.exports = {"label":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___bjlJ_","sublabel":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___3dw5i","form-group":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___2enBS","field-right":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___dizLh","additional-text":"app-components-Fields-ReduxForm-DescriptiveSwitchField-__DescriptiveSwithField___1gBTS"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Fields/ReduxForm/DescriptiveSwitchField/DescriptiveSwithField.css
// module id = 2169
// module chunks = 0